import { render, staticRenderFns } from "./UpdateTyreStatus.vue?vue&type=template&id=322986fa&scoped=true&"
import script from "./UpdateTyreStatus.vue?vue&type=script&lang=js&"
export * from "./UpdateTyreStatus.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTyreStatus.vue?vue&type=style&index=0&id=322986fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322986fa",
  null
  
)

export default component.exports